export function getUserAgent(): string {
  return typeof window !== 'undefined' ? window.navigator.userAgent : ''
}

export function getOS(userAgent: string): string {
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios'
  }
  if (/Android/i.test(userAgent)) {
    return 'android'
  }
  return 'other'
}

export function getVersion(userAgent: string, os: string): string | null {
  if (os === 'ios') {
    const match = userAgent.match(/OS\s+(\d+)(?:_(\d+))?(?:_(\d+))?/)
    if (match && match[1]) {
      const major = match[1]
      const minor = match[2]
      const patch = match[3]
      let version = major
      if (minor) version += `.${minor}`
      if (patch) version += `.${patch}`
      return version
    }
  }
  if (os === 'android') {
    const match = userAgent.match(/Android\s+(\d+(\.\d+){1,2})/)
    if (match && match[1]) {
      return match[1]
    }
  }
  return null
}
